import config from 'config'
import graphql from 'api/graphql'
import { load } from 'recaptcha-v3'
import { oauthTokenSelector } from 'selectors/app'
import { doAuthenticateFromToken } from 'actions/auth'
import { doReloadTokenInfo } from 'ducks/tokens/actions'
import { basicFields as accountFields } from 'api/account'
import { signupFields as userFields } from 'ducks/currentUser/api'
import {
  getSignupAccountAttributes,
  getMarketingAttribution,
} from '../../utils'
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from '../../types'
import { V4_USER_PAGE } from '../pages'

function getReCaptchaToken() {
  return load(config.google_recaptcha_site_key).then(recaptcha =>
    recaptcha.execute('signup')
  )
}

export function doSaveAndRedirect({ emailInput, password }) {
  return (dispatch, getState) => {
    return getReCaptchaToken().then(reCaptchaToken => {
      const state = getState()
      const token = oauthTokenSelector(state)

      const signup = {
        authenticity_token: 'TOKEN',
        recaptcha_token: reCaptchaToken,
        source: 'marketing',
        user: {
          account_attributes: {
            ...getSignupAccountAttributes(),
            type: 'helpdesk',
            onboarding_version: 2,
          },
          consents: {
            marketing: true,
            privacy_and_terms: true,
          },
          marketing_attribution: getMarketingAttribution(),
          email: emailInput,
          password,
        },
        utf8: '✓',
      }

      dispatch({
        type: SIGNUP_REQUEST,
        data: { signup },
      })

      const mutation = `
        mutation signupAccount(
          $input: SignupInput!
        ){
          signupAccount(
            input: $input
          ) {
            account {
              ${accountFields}
            }
            user {
              ${userFields}
            }
          }
        }
      `

      const variables = {
        input: signup,
      }

      return graphql(token, mutation, variables)
        .then(res => {
          const data = res.json.data
          const { account, user } = data.signupAccount
          // HACK (jscheel): Having three dispatches here is terrible, but
          // refactoring how our actions and reducers respond to signups and
          // logins will have to wait for another day.
          dispatch({
            type: SIGNUP_SUCCESS,
            payload: { account, user },
          })
          dispatch(doAuthenticateFromToken(user.token, user.expiresAt))
          dispatch(doReloadTokenInfo())
          dispatch({
            type: V4_USER_PAGE,
          })
        })
        .catch(err => {
          dispatch({
            type: SIGNUP_FAILURE,
            payload: { error: err },
          })
        })
    })
  }
}
